import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const AddSupplierModal = ({ isOpen, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    name: '',
    contact_person: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postal_code: '',
    country: 'France',
    website: '',
    notes: ''
  });

  const handleSubmit = (e) => {
    e?.preventDefault();
    onAdd(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1020] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="bg-card rounded-lg shadow-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto animate-scale-in">
        <div className="p-6 border-b border-border sticky top-0 bg-card">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name="Building2" size={24} className="text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground">Ajouter un fournisseur</h3>
                <p className="text-sm text-muted-foreground">Remplissez les informations du nouveau fournisseur</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Nom du fournisseur"
              type="text"
              placeholder="Ex: PlombPro"
              value={formData?.name}
              onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
              required
            />

            <Input
              label="Personne de contact"
              type="text"
              placeholder="Ex: Jean Dupont"
              value={formData?.contact_person}
              onChange={(e) => setFormData({ ...formData, contact_person: e?.target?.value })}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Email"
              type="email"
              placeholder="contact@fournisseur.fr"
              value={formData?.email}
              onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
            />

            <Input
              label="Téléphone"
              type="tel"
              placeholder="01 23 45 67 89"
              value={formData?.phone}
              onChange={(e) => setFormData({ ...formData, phone: e?.target?.value })}
            />
          </div>

          <Input
            label="Adresse"
            type="text"
            placeholder="15 Rue de la Plomberie"
            value={formData?.address}
            onChange={(e) => setFormData({ ...formData, address: e?.target?.value })}
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Ville"
              type="text"
              placeholder="Paris"
              value={formData?.city}
              onChange={(e) => setFormData({ ...formData, city: e?.target?.value })}
            />

            <Input
              label="Code postal"
              type="text"
              placeholder="75001"
              value={formData?.postal_code}
              onChange={(e) => setFormData({ ...formData, postal_code: e?.target?.value })}
            />

            <Input
              label="Pays"
              type="text"
              placeholder="France"
              value={formData?.country}
              onChange={(e) => setFormData({ ...formData, country: e?.target?.value })}
            />
          </div>

          <Input
            label="Site web"
            type="url"
            placeholder="www.fournisseur.fr"
            value={formData?.website}
            onChange={(e) => setFormData({ ...formData, website: e?.target?.value })}
          />

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Notes
            </label>
            <textarea
              placeholder="Informations supplémentaires..."
              value={formData?.notes}
              onChange={(e) => setFormData({ ...formData, notes: e?.target?.value })}
              rows={3}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            />
          </div>

          <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} className="text-primary mt-0.5" />
              <div className="text-xs text-primary">
                <p className="font-medium mb-1">Information</p>
                <p>Les fournisseurs peuvent être associés aux consommables pour faciliter le réapprovisionnement.</p>
              </div>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Plus"
              className="flex-1"
            >
              Ajouter
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSupplierModal;